import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Calendar from "./components/Calendar";
import Customers from "./components/Customers";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Event from "./pages/Event";
import Login from "./login/Login";
import { useEffect } from "react";
import NewEvent from "./components/NewEvent";
import BlankFrame from "./components/BlankFrame";
import Customer from "./components/Customer";
import { SiteProvider } from "./context/SiteContext";
import SummaryList from "./reports/SummaryList";
import Menu from "./components/Menu";
import Users from "./components/Users";

function App() {
  const isUserLoggedIn = () => {
    const now = new Date();
    const data = JSON.parse(localStorage.getItem("userLogin"));
    if (data == null || now.getTime() > data.expiry) {
      localStorage.removeItem("userLogin");
      return false;
    } else {
      localStorage.setItem("userLogin", JSON.stringify({ ...data, expiry: now.getTime() + 3600000 }));
      // sessionStorage.setItem("token", data.token);
      // sessionStorage.setItem("user", data.user);
      // sessionStorage.setItem("location", data.location);
      // sessionStorage.setItem("userId", data.userId);

      return true;
    }
  };

  // useEffect(() => {
  //   document.title = "GVB Banquetscheduler";
  // }, []);

  if (!isUserLoggedIn()) {
    return <Login />;
  } else {
    return (
      //<SiteProvider>
      <>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Homepage />}>
              <Route index element={<Calendar />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<Customer />} />
              <Route path="newevent" element={<NewEvent />} />
            </Route>
            <Route path="event/:id" element={<Event />} />
            <Route path="settings" element={<Settings />}>
              <Route index element={<BlankFrame>SETTINGS</BlankFrame>} />
              <Route path="menu" element={<Menu />} />
              <Route path="users" element={<Users />} />
            </Route>
            <Route path="reports" element={<Reports />}>
              <Route index element={<BlankFrame>REPORTS</BlankFrame>} />
              <Route path="summary" element={<SummaryList />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </>
      //</SiteProvider>
    );
  }
}

export default App;
